import React from "react";
import HeroSection from "../sections/automate/HeroSection";
import ServicesGrid from "../sections/automate/ServicesGrid";
import ProcessSection from "../sections/automate/ProcessSection";
import CTASection from "../sections/automate/CTASection";
import { LanguageCode } from "../utils/translations";

interface AutomateBusinessProps {
  lang?: LanguageCode;
}

const AutomateBusiness: React.FC<AutomateBusinessProps> = ({ lang = "en" }) => {
  return (
    <>
      <HeroSection lang={lang} />
      <ServicesGrid lang={lang} />
      <ProcessSection lang={lang} />
      <CTASection lang={lang} />
    </>
  );
};

export default AutomateBusiness;
